import React from 'react';

export const pause = {
  width: 9,
  height: 11,
  content: <path d="M0 0h3v11H0zM6 0h3v11H6z" />
};
